import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const TopFieldsByQueryCount = () => {
  const data = [
    { field: "AE Start Date", count: 30 },
    { field: "Creatinine", count: 28 },
    { field: "Causality", count: 27 },
    { field: "Platelets", count: 25 },
    { field: "Severity Grade", count: 25 },
    { field: "Dose", count: 25 },
    { field: "AE Term", count: 23 },
    { field: "Heart Rate", count: 23 },
    { field: "AE End Date", count: 23 },
    { field: "Lot Number", count: 23 },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        borderRadius: 4,
        barHeight: "72%",
      },
    },

    colors: data.map((_, index) => (index < 6 ? "#e52421" : "#f59e0b")),

    dataLabels: {
      enabled: false,
    },

    legend: {
      show: false,
    },

    xaxis: {
      categories: data.map((item) => item.field),
      min: 0,
      max: 30,
      tickAmount: 6,
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} queries`,
      },
    },
  };

  const series = [
    {
      name: "Queries",
      data: data.map((item) => item.count),
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </>
  );
};

export default TopFieldsByQueryCount;
